import { AxiosResponse } from "axios";
import { error } from "console";


export function formatIsoDate(input: string | undefined | null): string {
    if (!input)
        return "";

    const dateFormatOptions: Intl.DateTimeFormatOptions = {
        timeStyle: "medium",
        dateStyle: "short",
    };
    let asDate = Date.parse(input);
    return (new Intl.DateTimeFormat("en-US", dateFormatOptions)).format(asDate);
}

export function formatDate(input: Date): string {
    const dateFormatOptions: Intl.DateTimeFormatOptions = {
        timeStyle: "medium",
        dateStyle: "short",
    };
    return (new Intl.DateTimeFormat("en-US", dateFormatOptions)).format(input);
}

export function formatNumberString(input: number | undefined | null): string {
    return Intl.NumberFormat("en-US").format(input ?? 0);
}

export function getErrorMessageFromResponse(response: AxiosResponse): string {
    if (!response || !response.data)
        return "(unknown error)";

    if (response.data.hasOwnProperty("hasError") && response.data.hasError === true) {
        if (response.data.hasOwnProperty("errorDescription")) {
            let errorDescription = response.data.errorDescription;
            if (errorDescription && errorDescription.length > 0) {
                return errorDescription;
            }
        }
    }
    return "(unknown error)";
}

export function pluralizeCount(count: number | undefined | null, resultText: string, pluralize: string): string {
    if (!count)
        return `0 ${resultText}${pluralize}`;
    return `${count} ${resultText}${count !== 1 ? pluralize : ""}`;
}